/**
 * Zombies horde deck.
 * Source: hordemagic.com "the original Horde" (300 cards: 200 tokens / 100 nontoken).
 * Scaled to ~100 cards preserving the 2:1 token:nontoken ratio.
 * All nontoken card names verified against local card DB.
 * Tokens: "Zombie" (0397aa00) and "Zombie Giant" (094ceb6a) — real Scryfall printings.
 */
export const zombiesDeck = {
    id: 'zombies',
    name: 'Rise of the Dead',
    description: 'An endless tide of undead rises to overwhelm the living.',
    cards: [
        // ── Tokens (66 total: 62 Zombie + 4 Zombie Giant) ──────────────────────
        { name: 'Zombie', quantity: 62, isToken: true, scryfallId: '0397aa00-6d82-47d9-bc30-072b722c8b71' },
        { name: 'Zombie Giant', quantity: 4, isToken: true, scryfallId: '094ceb6a-51fa-4347-b1be-ae4a80b189be' },
        // ── Creatures (30) ──────────────────────────────────────────────────────
        { name: 'Corpse Knight', quantity: 1, isToken: false },
        { name: 'Death Baron', quantity: 2, isToken: false },
        { name: 'Diregraf Captain', quantity: 2, isToken: false },
        { name: 'Dread Slaver', quantity: 1, isToken: false },
        { name: 'Eternal Skylord', quantity: 1, isToken: false },
        { name: 'Fleshbag Marauder', quantity: 1, isToken: false },
        { name: 'Ghoultree', quantity: 1, isToken: false },
        { name: 'Gleaming Overseer', quantity: 1, isToken: false },
        { name: 'Grave Titan', quantity: 1, isToken: false },
        { name: 'Gray Merchant of Asphodel', quantity: 1, isToken: false },
        { name: 'Josu Vess, Lich Knight', quantity: 1, isToken: false },
        { name: 'Lotleth Giant', quantity: 1, isToken: false },
        { name: 'Mournwillow', quantity: 1, isToken: false },
        { name: 'Noosegraf Mob', quantity: 1, isToken: false },
        { name: 'Noxious Ghoul', quantity: 1, isToken: false },
        { name: 'Plague Belcher', quantity: 1, isToken: false },
        { name: 'Soulless One', quantity: 1, isToken: false },
        { name: 'Unbreathing Horde', quantity: 2, isToken: false },
        { name: 'Undead Alchemist', quantity: 1, isToken: false },
        { name: 'Undead Servant', quantity: 6, isToken: false },
        { name: 'Undead Warchief', quantity: 1, isToken: false },
        { name: 'Vengeful Pharaoh', quantity: 1, isToken: false },
        { name: 'Vulturous Zombie', quantity: 1, isToken: false },
        // ── Spells (4) ──────────────────────────────────────────────────────────
        { name: 'Zombie Apocalypse', quantity: 1, isToken: false },
        { name: 'Endless Ranks of the Dead', quantity: 1, isToken: false },
        { name: 'Army of the Damned', quantity: 1, isToken: false },
        { name: 'Grave Betrayal', quantity: 1, isToken: false },
    ],
};
//# sourceMappingURL=zombies.js.map